export default __webpack_public_path__ + "static/media/032-refrigerator.5c8e62ad.svg";